<ion-menu side="end" contentId="main-content" swipeGesture="false">
  <ion-menu-toggle>
    <ion-icon src="../../../../../assets/icon/tutorial_cerrar.svg"></ion-icon>
  </ion-menu-toggle>
  <ion-list lines="none">
    <ion-item>
      <ion-button fill="clear" (click)="navToHome()">
        <ion-icon name="home-outline" style="font-size: 1.2rem;padding-inline: 0.4rem;"></ion-icon>
        <span>Inicio</span>
      </ion-button>
    </ion-item>
    <ion-item>
      <ion-button fill="clear" (click)="navToStore()">
        <ion-icon src="../../../../../assets/icon/miscompras.svg"></ion-icon>
        <span>Tienda</span>
      </ion-button>
    </ion-item>
    <ion-item>
      <ion-button fill="clear" (click)="navToPurchaseHistory()">
        <ion-icon src="../../../../../assets/icon/menu_historial.svg" style="font-size: 20px;padding: 6px;"></ion-icon>
        <span>Mis Compras</span>
      </ion-button>
    </ion-item>
    <ion-item>
      <ion-button fill="clear" (click)="navToShoppingCart()">
        <ion-icon src="../../../../../assets/icon/carrodecompras.svg"></ion-icon>
        <span>Carro de Compras</span>
      </ion-button>
    </ion-item>
    <ion-item>
      <ion-button fill="clear" (click)="toggleDropdown()">
        <ion-icon src="../../../../../assets/icon/contactanos.svg" style="font-size: 20px;padding: 6px;"></ion-icon>
        <span>Contáctanos</span>
      </ion-button>
    </ion-item>
    <div class="dropdown-menu" [class.open]="isSelectorOpen">
      <ion-button fill="clear" (click)="goToCallCenter()">
        <span>Call Center</span>
      </ion-button>
      <ion-button fill="clear" (click)="goToWhatsapp()">
        <span>WhatsApp</span>
      </ion-button>
    </div>
  </ion-list>
</ion-menu>